module.exports = __webpack_public_path__ + "img/upcoming.884d42c0.png";